import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function CalendarIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || 512}
      height={height || 512}
      viewBox="0 0 36.447 36.447"
    >
      <g fill={color || "#555"} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M30.224 3.948h-1.098V2.75c0-1.517-1.197-2.75-2.67-2.75-1.474 0-2.67 1.233-2.67 2.75v1.197h-2.74V2.75c0-1.517-1.197-2.75-2.67-2.75-1.473 0-2.67 1.233-2.67 2.75v1.197h-2.74V2.75c0-1.517-1.197-2.75-2.67-2.75-1.473 0-2.67 1.233-2.67 2.75v1.197H6.224a4.255 4.255 0 00-4.25 4.25v24a4.255 4.255 0 004.25 4.25h24a4.255 4.255 0 004.25-4.25v-24a4.255 4.255 0 00-4.25-4.249zM25.286 2.75c0-.689.525-1.25 1.17-1.25.646 0 1.17.561 1.17 1.25v4.896c0 .689-.524 1.25-1.17 1.25-.645 0-1.17-.561-1.17-1.25V2.75zm-8.08 0c0-.689.525-1.25 1.17-1.25s1.17.561 1.17 1.25v4.896c0 .689-.525 1.25-1.17 1.25s-1.17-.561-1.17-1.25V2.75zm-8.081 0c0-.689.525-1.25 1.17-1.25s1.17.561 1.17 1.25v4.896c0 .689-.525 1.25-1.17 1.25s-1.17-.561-1.17-1.25V2.75zm22.849 29.448c0 .965-.785 1.75-1.75 1.75h-24c-.965 0-1.75-.785-1.75-1.75v-22h27.5v22z"
          data-original="#000000"
        />
        <path
          data-original="#000000"
          d="M6.724 14.626H11.318999999999999V18.715H6.724z"
        />
        <path
          data-original="#000000"
          d="M12.857 14.626H17.453V18.715H12.857z"
        />
        <path data-original="#000000" d="M18.995 14.626H23.59V18.715H18.995z" />
        <path
          data-original="#000000"
          d="M25.128 14.626H29.724V18.715H25.128z"
        />
        <path
          data-original="#000000"
          d="M6.724 20.084H11.318999999999999V24.17H6.724z"
        />
        <path data-original="#000000" d="M12.857 20.084H17.453V24.17H12.857z" />
        <path data-original="#000000" d="M18.995 20.084H23.59V24.17H18.995z" />
        <path data-original="#000000" d="M25.128 20.084H29.724V24.17H25.128z" />
        <path
          data-original="#000000"
          d="M6.724 25.54H11.318999999999999V29.625999999999998H6.724z"
        />
        <path
          data-original="#000000"
          d="M12.857 25.54H17.453V29.625999999999998H12.857z"
        />
        <path
          data-original="#000000"
          d="M18.995 25.54H23.59V29.625999999999998H18.995z"
        />
        <path
          data-original="#000000"
          d="M25.128 25.54H29.724V29.625999999999998H25.128z"
        />
      </g>
    </svg>
  );
}
